import { Menu } from 'lucide-react';
import { ButtonHTMLAttributes, FC } from 'react';
import { cn } from '@/lib/utils';

type IHamburgerButtonProps = ButtonHTMLAttributes<HTMLButtonElement>;

const HamburgerButton: FC<IHamburgerButtonProps> = ({ className, ...props }) => {
  return (
    <button
      {...props}
      className={cn(
        'p-2 text-slate-600 hover:bg-slate-100 rounded-lg transition-colors flex items-center justify-center',
        className
      )}
    >
      <Menu className="w-6 h-6" />
    </button>
  );
};

export default HamburgerButton;
